/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Happy_Weak_Snake_PokeInputs */

const en_happy_weak_snake_poke = /** @type {(inputs: Happy_Weak_Snake_PokeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add ${i?.count} User`)
};

const de_happy_weak_snake_poke = /** @type {(inputs: Happy_Weak_Snake_PokeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Benutzer hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add {count} User" |
*
* @param {Happy_Weak_Snake_PokeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const happy_weak_snake_poke = /** @type {((inputs: Happy_Weak_Snake_PokeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Happy_Weak_Snake_PokeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_happy_weak_snake_poke(inputs)
	return de_happy_weak_snake_poke(inputs)
});